module.exports = __webpack_public_path__ + "public/images/drawing-techniques.668573595d315572cab4263bf931f02c.jpg";